import { css } from '@emotion/react'
import { SpacingToken } from '@livechat/design-system-react-components'

import VerticalList from 'gatsby-theme-marketplace-base/src/components/ProductList/VerticalList'

import mediaQueries from '../../../layout/media-queries'

const overrideCss = css`
  margin-bottom: 0;

  ${mediaQueries.smallScreen()} {
    margin-bottom: calc(0px - var(${SpacingToken.Spacing8}));
  }

  ${mediaQueries.xlargeScreen()} {
    margin-inline: calc(0px - var(${SpacingToken.Spacing4}));
  }
`

export default (props) => <VerticalList {...props} css={overrideCss} />
